import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'core/security.service';
import { ActivatedRoute } from '@angular/router';
import { SamplicityPermission } from 'dtp/common/permissions';

@Component({
  selector: 'samplicity-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errorMessage: string;

  constructor(
    private securityService: SecurityService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.handleSecurityErrors(params.code).then((handled) => {
        if (!handled) {
          this.errorMessage = 'Errors.GenericError';
        }
        if (params.noAccess) {
          this.errorMessage = 'Errors.InsufficientSamplicityUserPermissions';
        }
      });
    });
  }

  private handleSecurityErrors(code): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.securityService.userAccessSubject.subscribe((userAccess: any) => {
        if (userAccess) {
          if (userAccess.userId === 0) {
            this.errorMessage = 'Errors.NoSamplicityUser';
            resolve(true);
            return;
          }
          if (!userAccess.isActive) {
            this.errorMessage = 'Errors.InactiveSamplicityUser';
            resolve(true);
            return;
          }
          if (!userAccess.hasAllTenants && (!userAccess.tenants || userAccess.tenants.length === 0)) {
            this.errorMessage = 'Errors.NoTenantsPermission';
            resolve(true);
            return;
          }
          if (userAccess.permissions && userAccess.permissions.length > 0) {
            const hasNavigationPermission = SamplicityPermission.NavMapping.some(function(nm) {
              return userAccess.permissions.some(up => nm.Permission.toLowerCase() === up.toLowerCase());
            });
            if (!hasNavigationPermission) {
              this.errorMessage = 'Errors.InsufficientSamplicityUserPermissions';
              resolve(true);
              return;
            }
          } else {
            this.errorMessage = 'Errors.InsufficientSamplicityUserPermissions';
            resolve(true);
            return;
          }
          if (code === '401' || code === '403') {
            this.errorMessage = 'Errors.InsufficientSamplicityUserPermissions';
            resolve(true);
            return;
          }
        }
        resolve(false);
        return;
      });
    });
  }
}
